/** @internal */
export const OP_DIE = "Die";
/** @internal */
export const OP_EMPTY = "Empty";
/** @internal */
export const OP_FAIL = "Fail";
/** @internal */
export const OP_INTERRUPT = "Interrupt";
/** @internal */
export const OP_PARALLEL = "Parallel";
/** @internal */
export const OP_SEQUENTIAL = "Sequential";
//# sourceMappingURL=cause.js.map